import actions from './actions'
import getters from './getters'
import * as types from './types'
import Vue from 'vue'

const initialState = {
  ranges: null,
  index: null
}

const state = {
  ranges: null,
  index: null
}

const mutations = {
  [types.SET_RANGE_INDEX](state, action) {
    state.index = action.index
  },
  [types.SET_RANGE_ATTRIBUTE](state, action) {
    if (state.ranges != null) {
      if (state.ranges[action.attribute] == null) {
        state.ranges = { ...state.ranges, [action.attribute]: {
          limitFrom: action.limitFrom,
          limitTo: action.limitTo,
          from: null,
          to: null,
          errors: null
        } }
      } else {
        let existingRange = { ...state.ranges[action.attribute] }
        if (existingRange.limitFrom !==  action.limitFrom || existingRange.limitTo !== action.limitTo) {
          existingRange = { ...existingRange, limitFrom: action.limitFrom, limitTo: action.limitTo }
          state.ranges = { ...state.ranges, [action.attribute]: existingRange }
        }
      }
    } else {
      state.ranges = { ...state.ranges, [action.attribute]: {
        limitFrom: action.limitFrom,
        limitTo: action.limitTo,
        from: null,
        to: null,
        errors: null
      } }
    }

  },
  [types.SET_RANGE_FROM_TO](state, action) {
    const range = state.ranges[action.attribute]
    range.from = action.from
    range.to = action.to
    state.ranges = { ...state.ranges, [action.attribute]: range }
  },
  [types.SET_RANGE_ERROR](state, action) {
    const range = state.ranges[action.attribute]
    range.errors = action.errors
    state.ranges = { ...state.ranges, [action.attribute]: range }
  },
  [types.REMOVE_RANGE_FILTER](state, action) {
    const range = state.ranges[action.attribute]
    range.from = null
    range.to = null
    state.ranges = { ...state.ranges, [action.attribute]: range }
  },
  [types.REMOVE_ALL_RANGE_FILTERS](state, action) {
    const ranges = state.ranges
    if (ranges != null) {
      Object.keys(ranges).forEach((key) => {
        ranges[key].from = null
        ranges[key].to = null
      })
      state.ranges = { ...ranges }
    }
  },
  [types.RESET_STATE](state) {
    state = Object.assign(state, initialState)
  }
}

export const rangesFilters = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
